export const ProcessStep = {
    // for MA
    RECEIVE_PLATE: "RECEIVE_PLATE",
    STORE_PLATE: "STORE_PLATE",
    QC_SCAN: "QC_SCAN",
    LYSIS: "LYSIS",
    EXTRACTION: "EXTRACTION",
    NANODROP_FAIL: "NANODROP_FAIL",
    NANODROP_PASS: "NANODROP_PASS",
    ALIQUOTATION: 'ALIQUOTATION',
    AMPLIFY_WGA : "AMPLIFY_WGA",
    AMPLIFY_PGX : "AMPLIFY_PGX",
    RECOMBINE_DNA : "RECOMBINE_DNA",
    FRAGMENT_DNA : "FRAGMENT_DNA",
    PRECIPITATE_DNA : "PRECIPITATE_DNA",
    RESUSPEND_DNA : "RESUSPEND_DNA",
    DENATURATE_DNA : "DENATURATE_DNA",
    WGA_AND_PGX: "WGA_AND_PGX",
    SAFE_STOPPING: "SAFE_STOPPING",
    STORE_PGX_PLATE:"STORE_PGX_PLATE",
    FRAGMENT_SAFE_STOPPING: "FRAGMENT_SAFE_STOPPING",
    PRECIPITATE_SAFE_STOPPING:"PRECIPITATE_SAFE_STOPPING",
    RESUSPEND_SAFE_STOPPING:"RESUSPEND_SAFE_STOPPING",

    // for NGS
    UPLOAD_BATCH: "UPLOAD_BATCH",
    RECEIVE_BATCH: "RECEIVE_BATCH",
    TRANSFER_PLATE: "TRANSFER_PLATE",
    SAMPLE_QC: "SAMPLE_QC",
    NORMALIZATION: "NORMALIZATION",
    TAGMENTATION: "TAGMENTATION",
    INDEX_LIGATION: "INDEX_LIGATION",
    CLEAN_UP: "CLEAN_UP",
    LIBRARY_QC: "LIBRARY_QC",
    PURIFICATION: "PURIFICATION"
}

// The below list is for the dropdown in Admin Screen
export const ArrayPlateStatus = [
    {label: "RECEIVED", value: "RECEIVED"},
    {label: "STORED", value: "STORED"},
    {label: "START_PREPCR", value: "START_PREPCR"},
    {label: "WGA_COMPLETED", value: "WGA_COMPLETED"},
    {label: "PGX_COMPLETED", value: "PGX_COMPLETED"},
    {label: "PREPCR_COMPLETED", value: "PREPCR_COMPLETED"},
    {label: "RECOMBINING_STARTED", value: "RECOMBINING_STARTED"},
    {label: "RECOMBINING_COMPLETED", value: "RECOMBINING_COMPLETED"},
    {label: "FRAGMENTATION_STARTED", value: "FRAGMENTATION_STARTED"},
    {label: "FRAGMENTATION_COMPLETED", value: "FRAGMENTATION_COMPLETED"},
    {label: "PRECIPITATION_STARTED", value: "PRECIPITATION_STARTED"},
    {label: "PRECIPITATION_COMPLETED", value: "PRECIPITATION_COMPLETED"},
    {label: "RESUSPENDING_STARTED", value: "RESUSPENDING_STARTED"},
    {label: "RESUSPENDING_COMPLETED", value: "RESUSPENDING_COMPLETED"},
    {label: "DENATURATION_STARTED", value: "DENATURATION_STARTED"},
    {label: "DENATURATION_COMPLETED", value: "DENATURATION_COMPLETED"},
]

// The below list is for the dropdown in Admin Screen
export const ngsPlateStatus = [
    {label: "BATCH_RECEIVED", value: "BATCH_RECEIVED"},
    {label: "PLATE_TRANSFERRED", value: "PLATE_TRANSFERRED"},
    {label: "START_SAMPLE_QC", value: "START_SAMPLE_QC"},
    {label: "COMPLETE_SAMPLE_QC", value: "COMPLETE_SAMPLE_QC"},
    {label: "START_NORMALIZATION", value: "START_NORMALIZATION"},
    {label: "COMPLETE_NORMALIZATION", value: "COMPLETE_NORMALIZATION"},
    {label: "START_TAGMENTATION", value: "START_TAGMENTATION"},
    {label: "COMPLETE_TAGMENTATION", value: "COMPLETE_TAGMENTATION"},
    {label: "START_PURIFICATION", value: "START_PURIFICATION"},
    {label: "COMPLETE_PURIFICATION", value: "COMPLETE_PURIFICATION"},
    {label: "START_LIGATION", value: "START_LIGATION"},
    {label: "COMPLETE_LIGATION", value: "COMPLETE_LIGATION"},
    {label: "START_CLEAN_UP", value: "START_CLEAN_UP"},
    {label: "COMPLETE_CLEAN_UP", value: "COMPLETE_CLEAN_UP"},
    {label: "START_LIB_QC", value: "START_LIB_QC"},
    {label: "COMPLETE_LIB_QC", value: "COMPLETE_LIB_QC"}  
]

export const PlateStatus = {
    ANNOUNCED : "ANNOUNCED",
    RECEIVED : "RECEIVED",
    STORED : "STORED",
    PGX_PLATE_STORED: "PGX_PLATE_STORED",
    FRAGMENT_WGA_PLATE_STORED: "FRAGMENT_WGA_PLATE_STORED",
    RESUSPEND_WGA_PLATE_STORED: "RESUSPEND_WGA_PLATE_STORED",
    PRECIPITATE_WGA_PLATE_STORED: "PRECIPITATE_WGA_PLATE_STORED",
    ALIQUOTATION_STARTED: 'ALIQUOTATION_STARTED',
    ALIQUOTATION_COMPLETED: 'ALIQUOTATION_COMPLETED',
    START_PREPCR : "START_PREPCR",
    WGA_STARTED : "WGA_STARTED",
    WGA_COMPLETED : "WGA_COMPLETED",
    PGX_COMPLETED : "PGX_COMPLETED",
    PREPCR_COMPLETED : "PREPCR_COMPLETED",
    RECOMBINING_STARTED : "RECOMBINING_STARTED",
    RECOMBINING_COMPLETED : "RECOMBINING_COMPLETED",
    FRAGMENTATION_STARTED : "FRAGMENTATION_STARTED",
    FRAGMENTATION_COMPLETED : "FRAGMENTATION_COMPLETED",
    PRECIPITATION_STARTED : "PRECIPITATION_STARTED",
    PRECIPITATION_COMPLETED : "PRECIPITATION_COMPLETED",
    RESUSPENDING_STARTED : "RESUSPENDING_STARTED",
    RESUSPENDING_COMPLETED : "RESUSPENDING_COMPLETED",
    DENATURATION_STARTED : "DENATURATION_STARTED",
    DENATURATION_COMPLETED : "DENATURATION_COMPLETED",
    COMPLETLY_TRANSFERED : "COMPLETLY_TRANSFERED",
    COMPLETED : "COMPLETED",
    PLATE_CREATED: "PLATE_CREATED",
    RECEPTION_COMPLETED: "RECEPTION_COMPLETED",
    LYSIS_STARTED: "LYSIS_STARTED",
    LYSIS_COMPLETED: "LYSIS_COMPLETED",
    EXTRACTION_STARTED: "EXTRACTION_STARTED",
    EXTRACTION_COMPLETED: "EXTRACTION_COMPLETED",
    EXTRACTION_QC: "EXTRACTION_QC",
    QCSCAN_STARTED: "QCSCAN_STARTED",
    QCSCAN_COMPLETED: "QCSCAN_COMPLETED",
    MERGE_COMPLETED: "MERGE_COMPLETED",
    MERGED: "MERGED",
    STORAGE_PLATE: "STORAGE_PLATE",
    NEUTRALIZATION: "NEUTRALIZATION",
    AMPLIFICATION: "AMPLIFICATION",
    PLATE_REDO: "PLATE_REDO",

    // for NGS
    BATCH_UPLOADED: "BATCH_UPLOADED",
    BATCH_RECEIVED: "BATCH_RECEIVED",
    PLATE_TRANSFERRED: "PLATE_TRANSFERRED",
    START_NORMALIZATION: "START_NORMALIZATION",
    COMPLETE_NORMALIZATION: "COMPLETE_NORMALIZATION",
    START_LIGATION: "START_LIGATION",
    COMPLETE_LIGATION: "COMPLETE_LIGATION",
    START_LIB_QC: "START_LIB_QC",
    COMPLETE_LIB_QC: "COMPLETE_LIB_QC",
    START_SAMPLE_QC: "START_SAMPLE_QC",
    COMPLETE_SAMPLE_QC: "COMPLETE_SAMPLE_QC",
    START_TAGMENTATION: "START_TAGMENTATION",
    COMPLETE_TAGMENTATION: "COMPLETE_TAGMENTATION",
    START_PURIFICATION: "START_PURIFICATION",
    COMPLETE_PURIFICATION: "COMPLETE_PURIFICATION",
    START_CLEAN_UP: "START_CLEAN_UP",
    COMPLETE_CLEAN_UP: "COMPLETE_CLEAN_UP",
    SKIP_NORMALIZATION: "SKIP_NORMALIZATION"
}
export const BeadChipStatus = {
    LOADED : "LOADED",
    HYBRIDIZATION_STARTED : "HYBRIDIZATION_STARTED",
    HYBRIDIZATION_COMPLETED : "HYBRIDIZATION_COMPLETED",
    WASHING_STARTED : "WASHING_STARTED",
    WASHING_COMPLETED : "WASHING_COMPLETED",
    CHAMBER_ASSEMBLED : "CHAMBER_ASSEMBLED",
    CHAMBER_RACK_SETUP : "CHAMBER_RACK_SETUP",
    EXTENSION_STARTED : "EXTENSION_STARTED",
    EXTENSION_COMPLETED : "EXTENSION_COMPLETED",
    COATING_STARTED : "COATING_STARTED",
    COATING_COMPLETED : "COATING_COMPLETED",
    BEADCHIP_IMAGED : "BEADCHIP_IMAGED",
    COMPLETED : "COMPLETED",
    GENE_TITAN_PREP_STARTED: "GENE_TITAN_PREP_STARTED",
    GENE_TITAN_PREP_COMPLETED: "GENE_TITAN_PREP_COMPLETED",
    GENE_TITAN_LOADED: "GENE_TITAN_LOADED",
    RESULT_FILE_SENT: "RESULT_FILE_SENT",
    STAINING_STARTED:"STAINING_STARTED",
    STAINING_COMPLETED:"STAINING_COMPLETED",
    INCUBATION_STARTED:"INCUBATION_STARTED",
    INCUBATION_COMPLETED:"INCUBATION_COMPLETED",
    DRYING_STARTED:"DRYING_STARTED",
    DRYING_COMPLETED:"DRYING_COMPLETED",
    WASH_AND_STAIN_PREP: "WASH_AND_STAIN_PREP",
    WAITING_FOR_ANALYSIS: "WAITING_FOR_ANALYSIS",
    ANALYSIS_STARTED: "ANALYSIS_STARTED",
    DELIVERED: "DELIVERED",
    REDO: "REDO",
    PLATE_REDO: "PLATE_REDO"
}

// The below list is for the dropdown in Admin Screen
export const beadChipStatusDict = [
    {label: BeadChipStatus.LOADED, value: BeadChipStatus.LOADED},
    {label: BeadChipStatus.HYBRIDIZATION_STARTED, value: BeadChipStatus.HYBRIDIZATION_STARTED},
    {label: BeadChipStatus.HYBRIDIZATION_COMPLETED, value: BeadChipStatus.HYBRIDIZATION_COMPLETED},
    {label: BeadChipStatus.WASHING_STARTED, value: BeadChipStatus.WASHING_STARTED},
    {label: BeadChipStatus.WASHING_COMPLETED, value: BeadChipStatus.WASHING_COMPLETED},
    {label: BeadChipStatus.EXTENSION_STARTED, value: BeadChipStatus.EXTENSION_STARTED},
    {label: BeadChipStatus.EXTENSION_COMPLETED, value: BeadChipStatus.EXTENSION_COMPLETED},
    {label: BeadChipStatus.COATING_STARTED, value: BeadChipStatus.COATING_STARTED},
    {label: BeadChipStatus.COATING_COMPLETED, value: BeadChipStatus.COATING_COMPLETED},
    {label: BeadChipStatus.BEADCHIP_IMAGED, value: BeadChipStatus.BEADCHIP_IMAGED},
    {label: BeadChipStatus.COMPLETED, value: BeadChipStatus.COMPLETED},
]


export const BeadChipProcessStep = {
    LOADING: "LOADING",
    HYBRIDIZATION: 'HYBRIDIZATION',
    WASHING: "WASHING",
    ASSEMBLING_CHAMBER: "ASSEMBLING_CHAMBER",
    CHAMBER_RACK_SETUP: "CHAMBER_RACK_SETUP",
    EXTENSION: "EXTENSION",
    COATING: "COATING",
    COMPLETED: "COMPLETED",
    GENE_TITAN_PREPARATION: "GENE_TITAN_PREPARATION",
    RESULT_HANDLING: "RESULT_HANDLING",
    INCUBATION : "INCUBATION",
    STAINING : "STAINING",
    DRYING : "DRYING",
    EVALUTION : "EVALUTION"
}

export const PlateType = {
    STANDARD: "Standard Plate",
    STORAGE: "Storage Plate",
    REDO: "Redo Plate"
}

export const BatchTypes = {
    SAMPLE: "SAMPLE",
    PLATE: "PLATE"
}

export enum ProcessUpdateStage {
  COMPLETED,
  UNSUITABLE,
  STAGE_GATE,
  AUTO_RETEST,
  RETEST,
}

export enum Merge96Mode{
    HORIZONTAL,
    VERTICAL
}